import { render, staticRenderFns } from "./PropertyAttachDialog.vue?vue&type=template&id=4b5bcd87"
import script from "./PropertyAttachDialog.vue?vue&type=script&lang=ts"
export * from "./PropertyAttachDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports